export { EnrolComponent } from "./enrol_component";
